import { useEffect, useState } from 'react';
import video from '../1024.mp4';
import Searchbar from './SearchBar';
import LocationDisplay from './LocationDisplay';
import './css/Banner.css';
import TypingText from './TypingText'; // Import TypingText component

const suggestions = [
    'Kaderníctvo',
    'Údržbár',
    'Opravár',
    'Tetovanie',
    'Masér',
    'Kozmetička',
    'Salón pre psov',
    'Nechty',
];

function Banner() {

    return (
        <div className="banner">
            <video
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline="true"
            >
                <source src={video} type="video/mp4" />
            </video>

            <div className="overlay">
                <br />
                <br />
                <TypingText />
                <Searchbar />
                <LocationDisplay />
            </div>

        </div>
    );
}

export default Banner;
